<template>
  <component
    v-if="!createProps"
    :is="componentObject.component"
    v-bind="componentObject.props"
    v-on="componentObject.vOn"/>
</template>

<script>
import Statuses from 'components/common/blocks/Statuses.vue'
import TextField from 'components/common/inputs/TextField.vue'
import OrgsList from 'components/common/elements/OrgsList.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'
import CategoryDropDownTree from 'components/common/dialogs/CategoryDropDownTree.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'tenderFiters',
  data() {
    const that = this
    return {
      typeSpr: {
        tenderSubject: {
          component: 'TextField',
          valueKey: 'model',
          filterKey: 'value',
          props: {
            dataQa: 'toolbar-planning-name',
            className: 'pa-0',
            placeholder: that.$t('Planning.Name')
          },
        },
        categoryTitle: {
          component: 'CategoryDropDownTree',
          valueKey: 'model',
          filterKey: 'search',
          props: {
            dataQa: 'toolbar-category',
            inputType: 'filter',
            multiple: true,
            label: that.$t('Tenders.Category')
          },
        },
        organizations: {
          component: 'OrgsList',
          valueKey: 'model',
          filterKey: 'search',
          sprKey: 'organizations',
          props: {
            readonly: that.disabled,
            return_object: false
          },
        },
        biddingTypeTitle: {
          component: 'Statuses',
          valueKey: 'item',
          filterKey: '',
          sprKey: 'setItems',
          props: {
            dataQa: 'toolbar-bidding-type',
            item_key: 'biddingTypeId',
            item_title: 'titleRu',
            type: 'biddingTypeTitle',
            updateOnOpen: true
          },
        },
        tenderStatusTitle: {
          component: 'Statuses',
          valueKey: 'item',
          filterKey: '',
          sprKey: 'setItems',
          props: {
            dataQa: 'toolbar-tender-statuses',
            item_key: 'statusCode',
            item_title: 'title',
            type: 'tenderStatusTitle',
            updateOnOpen: true
          },
        },
        manager: {
          component: 'Statuses',
          valueKey: 'item',
          filterKey: '',
          sprKey: 'setItems',
          props: {
            dataQa: 'toolbar-manager',
            item_key: 'contactId',
            item_title: 'name',
            type: 'manager',
            updateOnOpen: true
          },
        },
        personalManagers: {
          component: 'Statuses',
          valueKey: 'item',
          filterKey: '',
          sprKey: 'setItems',
          props: {
            dataQa: 'toolbar-manager',
            item_key: 'userId',
            item_title: 'name',
            type: 'personalManagers',
            updateOnOpen: true
          },
        },
        contactPersonDepartment: {
          component: 'Statuses',
          valueKey: 'item',
          filterKey: '',
          sprKey: 'setItems',
          props: {
            dataQa: 'toolbar-departments',
            item_key: 'id',
            item_title: 'title',
            type: 'contactPersonDepartment',
            updateOnOpen: true
          },
        },
        tenderingPeriodEnd: {
          component: 'DateRangeDialog',
          valueKey: 'search',
          filterKey: 'search',
          props: {
            dataQa: 'toolbar-date-range',
          },
        },
        contractDate: {
          component: 'DateRangeDialog',
          valueKey: 'search',
          filterKey: 'search',
          props: {
            dataQa: 'toolbar-date-range',
          },
        },
        tenderCreatedDate: {
          component: 'DateRangeDialog',
          valueKey: 'search',
          filterKey: 'search',
          props: {
            dataQa: 'toolbar-date-range',
          },
        },
        publishedDate: {
          component: 'DateRangeDialog',
          valueKey: 'search',
          filterKey: 'search',
          props: {
            dataQa: 'toolbar-date-range',
          },
        },
        tenderBudjet: {
          component: 'TextField',
          valueKey: 'model',
          filterKey: 'value',
          props: {
            dataQa: 'toolbar-personalManagers',
            placeholder: that.$t('Tenders.Budget'),
            rules: [ that.checkBudjetText ]
          },
        },
      },
      componentSpr: [],
      createProps: true
    }
  },
  methods: {
    updateVal(val, prop) {
      if (JSON.stringify(prop ? this.mutableItem[prop] : this.mutableItem) === JSON.stringify(val)) {
        return
      }
      const result = prop ? this.$_.cloneDeep(this.mutableItem) : val

      if (prop) {
        result[prop] = val
      }

      this.mutableItem = result
    },
    checkBudjetText(txt) {
      let error = txt?.match(/[^\d]/g)
      return error ? error.join('') : true
    },
    async createComponentProps(key) {
      this.createProps = true
      switch (key) {
      case 'organizations':
        this.componentSpr = this.organizations
        break
      case 'biddingTypeTitle':
        await this.$store.dispatch('setAllBiddingTypes')
          .then((result) => {
            this.componentSpr = result || []
          })
        break
      case 'tenderStatusTitle':
        await this.$store.dispatch('setTenderStatuses')
          .then((result) => {
            this.componentSpr = result || []
          })
        break
      case 'contactPersonDepartment':
        await this.$store.dispatch('setDepartments', [])
          .then((result) => {
            this.componentSpr = result || []
          })
        break
      case 'manager':
        await this.$store.dispatch('tenderContactPersons')
          .then((result) => {
            this.componentSpr = this.$_.sortBy((result ),'name') || []
          })
        break
      case 'personalManagers':
        await this.$store.dispatch('personalManagers')
          .then((result) => {
            this.componentSpr = result || []
          })
        break
      }
      this.createProps = false
    }
  },
  computed: {
    ...mapGetters({
      organizations: 'getAvailableOrganizationsForCurrently',
    }),
    componentObject() {
      const result = this.typeSpr[this.mutableItem.id]
      result.props[result.valueKey] = result.filterKey ? this.mutableItem[result.filterKey] : this.mutableItem
      if (result.sprKey) {
        result.props[result.sprKey] = this.componentSpr
      }
      result.vOn = {
        [`update:${result.valueKey}`]: result.filterKey
          ? val => this.updateVal(val, result.filterKey)
          : val => this.mutableItem = val
      }
      return result
    },
    dynamicEvent() {
      return `@update:${this.componentObject.valueKey}`
    },
    mutableItem: {
      get() {
        return this.item
      },
      set(newValue) {
        if (this.item === newValue) {
          return
        }
        this.$emit('update:item', newValue)
      }
    }
  },
  watch: {
    'mutableItem.id': {
      handler(value) {
        this.createComponentProps(value)
      },
      immediate: true,
    }
  },
  components: {
    Statuses,
    OrgsList,
    TextField,
    DateRangeDialog,
    CategoryDropDownTree,
  },
  props: {
    item: Object,
    disabled: Boolean
  },
}
</script>
